import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import DOMPurify from 'dompurify'

import { cn } from '@rewardops/ui'
import { invertHex, type Section } from '@rewardops/utils'

import AdButton from './adButton'
import ContentfulImage from './contentfulImage'

type Props = {
  content: Section
}

function FullWidthCard(props: Props) {
  const { content } = props
  const {
    id,
    contentImages,
    headingText,
    content: textContent,
    linkText,
    productUrl,
    backgroundColor = 'FFFFFF',
  } = content
  const textColor = invertHex(backgroundColor)

  const htmlContent = documentToHtmlString(textContent as any)

  return (
    <div
      className="col-span-2 flex flex-col items-center px-2 pb-0"
      style={{
        backgroundColor: `#${backgroundColor || 'FFFFFF'}`,
        color: textColor,
      }}
    >
      <div className="mx-auto mb-16 mt-0 w-full max-w-6xl rounded-2xl bg-white bg-opacity-95 p-8 px-9 shadow-xl">
        {headingText && (
          <div className="mb-2 text-3xl font-bold text-gray-900">
            {headingText}
          </div>
        )}
        {htmlContent && (
          <div className="mb-4 text-base font-normal text-gray-700">
            <span
              className="[&_a:hover]:underline [&_a]:text-tenant-primary-color"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(htmlContent),
              }}
            />
          </div>
        )}
        {linkText && productUrl ? (
          <div className="mt-4 flex justify-center">
            <AdButton
              id={id}
              href={productUrl}
              aria-label={`${linkText}: ${headingText}`}
              className="rounded-full bg-tenant-primary-color px-6 py-2 font-semibold text-white shadow transition hover:bg-opacity-80"
            >
              {linkText}
            </AdButton>
          </div>
        ) : undefined}
      </div>
      {contentImages?.[0]?.image && (
        <div className="flex w-full justify-center">
          <ContentfulImage
            content={contentImages[0].image}
            label={headingText ?? 'Ad Image'}
            className={cn('h-auto w-auto rounded-xl shadow-lg')}
            height="auto"
            width="auto"
            maxHeight="26rem"
            maxWidth="min(32rem, 100%)"
          />
        </div>
      )}
    </div>
  )
}

export default FullWidthCard
